<template>
  <div class="templateData h100">
    <el-card>
      <h1>This is an templateData page</h1>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'templateData',
  data () {
    return {}
  },
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style lang="less" scoped>

</style>
